import { api } from '@/lib/api-client';

export interface EmailDeadRow {
  id: string;
  kind: string;
  lastError: string | null;
  updatedAt: string;
}

export interface EmailRecentFailures {
  count7d: number;
  lastError: string | null;
  lastAt: string | null;
  // Up to 10 newest dead rows — each individually redrivable (v1.1).
  deadRows: EmailDeadRow[];
}

export interface EmailSettingsState {
  enabled: boolean;
  host: string;
  port: number;
  secure: boolean;
  username: string;
  fromAddress: string;
  fromName: string;
  opsRecipients: string[];
  hasPassword: boolean;
  updatedAt: string | null;
  recentFailures: EmailRecentFailures;
}

export interface EmailSettingsPutBody {
  enabled: boolean;
  host: string;
  port: number;
  secure: boolean;
  username?: string;
  fromAddress: string;
  fromName?: string;
  opsRecipients: string[];
  // Omitted → preserve stored password. `null` → clear it. A string → rotate it.
  password?: string | null;
}

export interface EmailTestResult {
  ok: boolean;
  error?: string;
}

export function get(): Promise<EmailSettingsState> {
  return api.get<EmailSettingsState>('/admin/email');
}

export function put(body: EmailSettingsPutBody): Promise<void> {
  return api.put<void>('/admin/email', body);
}

export function test(): Promise<EmailTestResult> {
  return api.post<EmailTestResult>('/admin/email/test');
}

// v1.1 — reset a dead outbox row for redrive; the worker's next drain tick
// picks it up (status → pending, expired window, retrying attempts).
export function redriveOutboxRow(id: string): Promise<void> {
  return api.post<void>(`/admin/email/outbox/${encodeURIComponent(id)}/redrive`);
}
